import {
  actions,
  getAllInterestsAsync,
  getUserInterestsAsync,
  setUserInterestsAsync,
} from './slices';

export const InterestsActions = {
  ...actions,
  getAllInterestsAsync,
  getUserInterestsAsync,
  setUserInterestsAsync,
};

export * from './thunkHandlers';
